module.exports = __webpack_public_path__ + "media/toolkits/COVID-desktop-ecosystem-792677f6.png";